/* eslint-disable no-mixed-operators */
/* eslint-disable @typescript-eslint/ban-ts-comment */
const getValue = (value: string | number) => typeof value === 'string' ?
    value.toString().toLowerCase() : value

export const sortLeaderboard = (leaderboardSort: LeaderboardSort) => ((dataRecordA: ApiLeaderboardDataRecord, dataRecordB: ApiLeaderboardDataRecord): number => {
    // @ts-ignore
    const valueA = getValue(dataRecordA[leaderboardSort.column])
    // @ts-ignore
    const valueB = getValue(dataRecordB[leaderboardSort.column])
    if (valueA < valueB) {
        return leaderboardSort.sortAscending ? -1 : 1
    } else if (valueA === valueB) {
        if (leaderboardSort.column === 'name') {
            return 0
        }
        return sortLeaderboard({ ...leaderboardSort, column: 'name', sortAscending: true })(dataRecordA, dataRecordB)
    }
    return leaderboardSort.sortAscending ? 1 : -1

})

export const getDefaultSort = (sort: DataSourceType,scoreboardTypeId:number): LeaderboardSort => {
    switch (sort) {
        case 'Participation':
            return { column: 'recordCount', sortAscending: false }
        case 'PercentageOfGoal':
            if(scoreboardTypeId === 13){
                return { column: 'percentageOfAllGifts', sortAscending: false }
            }else{
                return { column: 'percentageOfGoal', sortAscending: false }
            }                    
        default:
            // We need a default case in case things go horribly wrong at runtime
            // We need to explicitly test this line for coverage
            // But we can't pass in garbage data because typescript won't let us pass in a value that isn't on DataSourceType
            // So here we are using the default case to return totalDollars instead of providing an explicit case for Dollars
            // yaaaaaay
            return { column: 'totalDollars', sortAscending: false }
    }
}

export const calculateBonus = (
    data: SortableLeaderboardDataRecord[],
    bonusAmount: number,
    distributionType: number | undefined,
    displayBonusAmount: boolean,
    distributionMethodType?: number,
    rankedDistribution?: RankedDistribution[],
    numberOfRanks?: number): SortableLeaderboardDataRecord[] => {
    if (displayBonusAmount && distributionMethodType === 1 && distributionType === 1) {
        return data.map(record => ({
            ...record,
            calculatedBonus: (bonusAmount * (record.percentageOfAllGifts / 100)),
        }))
    }
    if (displayBonusAmount && distributionMethodType === 1 && distributionType === 2) {
        return data.map(record => ({
            ...record,
            calculatedBonus: (bonusAmount * (record.percentageOfAllContributers / 100)),
        }))
    }
    if (displayBonusAmount && distributionMethodType === 2 && numberOfRanks) {
        return data.map((record, i) => ({
            ...record,
            calculatedBonus: (rankedDistribution && (rankedDistribution[i] && (rankedDistribution[i].dollars > 0))) ? Number(rankedDistribution[i].dollars) : 0,
        }))
    }

    return data
}

export const mapGoalAmount = (data: SortableLeaderboardDataRecord[], enableGoals: boolean, displayGoals: boolean, displayPercentageofGoals: boolean, goals: GoalDto[]): SortableLeaderboardDataRecord[] => {
    if (enableGoals && displayGoals || enableGoals && displayPercentageofGoals) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return data.map((record, i) => ({
            ...record,
            goalAmount: goals.find(x => x.id === record.id)!.goalAmount,
        }))
    }

    return data
}

export const calculateGoalPercentage = (
    data: SortableLeaderboardDataRecord[],
    enableGoals: boolean,
    displayPercentageOfGoals: boolean,
    defaultGoals: string,
    enableGoalTracking: boolean): SortableLeaderboardDataRecord[] => {
    if (enableGoals && displayPercentageOfGoals) {
        if (defaultGoals === 'Dollars') {
            if (enableGoalTracking) {
                return data.map(record => ({
                    ...record,
                    percentageOfGoal: record.goalAmount ? (Number(record.totalDollars) / Number(record.goalAmount)) * 100 : 0,
                }))
            }
            return data.map(record => ({
                ...record,
                percentageOfGoal: record.goalAmount && ((Number(record.totalDollars) / Number(record.goalAmount)) * 100) > 100 ? 100 : (record.goalAmount ? (Number(record.totalDollars) / Number(record.goalAmount)) * 100 : 0),
            }))
        }
        if (defaultGoals === 'Participation') {
            if (enableGoalTracking) {
                return data.map(record => ({
                    ...record,
                    percentageOfGoal: record.goalAmount ? (Number(record.recordCount) / Number(record.goalAmount)) * 100 : 0,
                }))
            }
            return data.map(record => ({
                ...record,
                percentageOfGoal: record.goalAmount && ((Number(record.recordCount) / Number(record.goalAmount)) * 100) > 100 ? 100 : (record.goalAmount ? (Number(record.recordCount) / Number(record.goalAmount)) * 100 : 0),
            }))
        }
    }

    return data
}
